import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingOverviewScreen } from '@/experiences/sales-portal/domain/pricing/screens/overview/pricing-overview-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';

export const PricingOverviewScreenWrapper: React.FC = () => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const { loading, error, hasPricingAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    if (!loading && !error && !hasPricingAccess) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [error, hasPricingAccess, loading, navigation]);

  return loading ? <LogoLoadingIndicator /> : <PricingOverviewScreen />;
};
